import React from 'react'
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <>
            {/* <!-- Start Hero Section --> */}
            <div class="hero">
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-lg-5">
                            <div class="intro-excerpt">
                                <h1>About Us</h1>
                                <p class="mb-4">Welcome to SpringUp Mattress — your trusted destination for premium mattresses and pillows designed to give you the sleep you deserve. We’re here to make buying a mattress or pillow online simple, affordable, and stress-free.</p>
                                <p><Link to="/shopping" class="btn btn-secondary me-2">Shop Now</Link><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                                    <i className="fa-solid fa-phone"></i> &nbsp; Call Us
                                </a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Hero Section --> */}

            {/* <!-- Start Why Choose Us Section --> */}
            <div class="why-choose-section">
                <div class="container">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-lg-6">
                            <h2 class="section-title">Why Shop with SpringUp Mattress?</h2>
                            <p>At SpringUp Mattress, we believe that quality sleep leads to a better life. That's why we focus exclusively on crafting premium mattresses and pillows that combine comfort, durability, and innovation. With easy online shopping, fast delivery, and unmatched customer support, we make your mattress-buying experience seamless and stress-free.</p>

                            <p>Whether you're upgrading your sleep or supporting your posture, SpringUp has your back — literally.</p>

                            <div class="row my-5">
                                <div class="col-6 col-md-6">
                                    <div class="feature">
                                        <div class="icon">
                                            <img src="images/truck.svg" alt="Image" class="imf-fluid" />
                                        </div>
                                        <h3>Fast Shipping</h3>
                                        <p>We understand the excitement of better sleep. That’s why we offer quick and reliable shipping across India. Your mattress or pillow reaches your doorstep safely and swiftly.</p>
                                    </div>
                                </div>

                                <div class="col-6 col-md-6">
                                    <div class="feature">
                                        <div class="icon">
                                            <img src="images/bag.svg" alt="Image" class="imf-fluid" />
                                        </div>
                                        <h3>Easy to Shop</h3>
                                        <p>Shopping for sleep essentials should be stress-free. Our user-friendly website and clear size guides make it simple to find and order the perfect mattress or pillow — all from the comfort of your home.</p>
                                    </div>
                                </div>

                                <div class="col-6 col-md-6">
                                    <div class="feature">
                                        <div class="icon">
                                            <img src="images/support.svg" alt="Image" class="imf-fluid" />
                                        </div>
                                        <h3>24/7 Support</h3>
                                        <p>Questions? Concerns? We're here for you — anytime, day or night. Our dedicated support team is available 24/7 to help you make the best choice or resolve any issue promptly.</p>
                                    </div>
                                </div>

                                <div class="col-6 col-md-6">
                                    <div class="feature">
                                        <div class="icon">
                                            <img src="images/return.svg" alt="Image" class="imf-fluid" />
                                        </div>
                                        <h3>Hassle Free Returns</h3>
                                        <p>Your satisfaction matters. Not happy with your purchase? We offer a simple and transparent return process to ensure your peace of mind. Certain products even come with a 100-night risk-free trial.</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-5">
                            <div class="img-wrap">
                                <img src="images/su_roundcornerC.jpg" alt="Image" class="img-fluid" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- End Why Choose Us Section --> */}

            <div class="product-section">
                <div class="container">
                    <div class="row">

                        {/* <!-- Start Column 2 --> */}
                        <div class="col-12 col-md-6 col-lg-6 mb-5 mb-md-0">
                            {/* <Link class="product-item" to="cart.html"> */}
                            <img src="images/su_Leaflet-F.jpg" class="img-fluid product-thumbnail" style={{ height: "400px", width: "1450px" }} />
                            {/* <h3 class="product-title">All Type Mattress</h3> */}

                            {/* <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link> */}
                        </div>
                        {/* <!-- End Column 2 --> */}

                        {/* <!-- Start Column 1 --> */}
                        <div class="col-md-12 col-lg-5 mb-5 mb-lg-0">
                            <h2 class="mb-4 section-title" style={{ fontFamily: "postmans-serif" }}>Your search for high-quality sleep essentials ends here.</h2>
                            <p class="mb-4">Welcome to SpringUp Mattress — your trusted destination for premium mattresses and pillows designed to give you the sleep you deserve. We’re here to make buying a mattress or pillow online simple, affordable, and stress-free.</p>

                            <p>At SpringUp, we believe that better sleep leads to a better life. OurOrthopedic Memory Foam Mattresses are engineered to provide superior backsupport, optimal spinal alignment, and pressure relief for uninterrupted,deep sleep. If you're looking for flexibility, our Dual Comfort Mattressesgive you the option of both soft and firm surfaces — just flip and sleep yourway.</p>
                            <p><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                                <i className="fa-solid fa-phone"></i> &nbsp; Call Us
                            </a></p>
                        </div>
                        {/* <!-- End Column 1 --> */}

                    </div>
                </div>
            </div>

            <div class="product-section">
                <div class="container">
                    <div class="row">

                        {/* <!-- Start Column 1 --> */}
                        <div class="col-md-12 col-lg-5 mb-5 mb-lg-0">
                            <h2 class="mb-4 section-title" style={{ fontFamily: "postmans-serif" }}>SpringUp Mattress — Where Better Sleep Begins..</h2>
                            <p class="mb-4">Don’t forget to complete your sleep setup with our high-quality sleeping pillows, crafted to cradle your head and neck with just the right support — whether you're a back, side, or stomach sleeper.</p>

                            <p>Everything we offer is available online at springupmattress.com. Our easy-to-follow size guide helps you choose the right mattress for your bed — be it queen size, king size, or custom dimensions.</p>

                            <p> Ready to experience restful nights?
                                Shop today and enjoy comfort backed by innovation. Select mattresses come with a 100-night risk-free trial so you can try before you commit.</p>
                            <p><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                                <i className="fa-solid fa-phone"></i> &nbsp; Call Us
                            </a></p>
                        </div>
                        {/* <!-- End Column 1 --> */}

                        {/* <!-- Start Column 2 --> */}
                        <div class="col-10 col-md-5 col-lg-5 mb-5 mb-md-0">
                            {/* <Link class="product-item" to="cart.html"> */}
                            <img src="images/NewAbout.jpg" class="img-fluid product-thumbnail" style={{ height: "400px", width: "1450px" }} />
                            {/* <h3 class="product-title">All Type Mattress</h3> */}

                            {/* <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link> */}
                        </div>
                        {/* <!-- End Column 2 --> */}

                    </div>
                </div>
            </div>
        </>
    )
}

export default About;